import React, { useState, useRef, useEffect } from "react";
import {
  QuickMenuContainer,
  MenuCategoryWrapper,
  CategoryButton,
  DropdownMenu,
  DropdownItem,
} from "./QuickMenu.style";

const menuCategories = [
  {
    id: "approval",
    title: "承認フロー",
    items: [
      { title: "承認待", path: "/approvallist" },
      { title: "承認済", path: "/approvaledlist" },
      { title: "否認済", path: "/rejectedlist" },
    ],
  },
  {
    id: "banner",
    title: "バナー管理",
    items: [
      { title: "大バナー", path: "/bannerManage" },
      { title: "小バナー", path: "/smallBannerManage" },
    ],
  },
  {
    id: "sys",
    title: "システム",
    items: [{ title: "データ移行", path: "/dataIko" }],
  },
];

export default function QuickMenu() {
  const [openMenu, setOpenMenu] = useState(null);
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setOpenMenu(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const toggleMenu = (categoryId) => {
    setOpenMenu(openMenu === categoryId ? null : categoryId);
  };

  return (
    <QuickMenuContainer ref={menuRef}>
      {menuCategories.map((category) => (
        <MenuCategoryWrapper key={category.id}>
          <CategoryButton onClick={() => toggleMenu(category.id)}>
            {category.title}
            <span>{openMenu === category.id ? "▲" : "▼"}</span>
          </CategoryButton>
          {openMenu === category.id && (
            <DropdownMenu>
              {category.items.map((item, index) => (
                <DropdownItem
                  to={item.path}
                  key={index}
                  onClick={() => setOpenMenu(null)}
                >
                  {item.title}
                </DropdownItem>
              ))}
            </DropdownMenu>
          )}
        </MenuCategoryWrapper>
      ))}
    </QuickMenuContainer>
  );
}
